import _ from 'lodash';
import { GOODIES } from '../constants';

function getGoodiesOfType(collectedGoodies, type) {
	return _
		.chain(collectedGoodies)
		.filter(goody => _.get(GOODIES[goody], 'type') === type)
		.value();
}

export default getGoodiesOfType;



// WEBPACK FOOTER //
// ./src/utils/getGoodiesOfType.js